export enum BucketFolders {
    BRANDS = "brands",
    CHAMPIONSHIPS = "championships",
    TRACKS = "tracks",
}
